import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { animateList } from 'src/shared/animations';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import { personnelFragments } from 'src/admin-app/personnel/personnel.routes';
import { AdminUsersPartialState } from '../+state/admin-user.reducer';
import { Store, select } from '@ngrx/store';
import * as AdminUserSelectors from '../+state/admin-user.selectors';
import { usersFragments } from '../../users.routes';
import { MatTableDataSource } from '@angular/material/table';
import { User, UserListArgs } from 'src/shared/api';
import { FilterCollection } from 'src/admin-app/utilities/list-filtering/shared';
import { FormControl, FormGroup } from '@angular/forms';
import { withAbstractControl } from 'src/admin-app/utilities/list-filtering';
import {
	debounceTime,
	distinctUntilChanged,
	filter,
	takeUntil,
} from 'rxjs/operators';
import { filtersUpdated } from '../+state/admin-user.actions';

@Component({
	templateUrl: './admin-user-list.component.html',
	animations: [animateList],
})
export class AdminUserListComponent
	extends SelfDestruct
	implements OnInit, AfterViewInit {
	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

	dataSource = new MatTableDataSource<User>([]);
	readonly filters = new FormGroup(
		{
			searchText: new FormControl('') as FormControl,
			pageNumber: new FormControl(-1),
		},
		{ updateOn: 'blur' }
	);
	readonly emptyColumns = ['empty'];
	readonly resultColumns = ['lastName', 'email', 'employee'];

	readonly isLoading$ = this.store.pipe(
		select(AdminUserSelectors.getListLoadingStatus)
	);
	readonly listMessage$ = this.store.pipe(
		select(AdminUserSelectors.getListMessage)
	);

	readonly usersFragments = usersFragments;
	readonly personnelFragments = personnelFragments;

	constructor(private readonly store: Store<AdminUsersPartialState>) {
		super();
	}

	ngOnInit() {
		this.store
			.pipe(select(AdminUserSelectors.getAllAdminUsers))
			.subscribe((users) => {
				this.dataSource.data = users || [];
			});
	}

	ngAfterViewInit() {
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort = this.sort;

		const filters = new FilterCollection<UserListArgs>(
			withAbstractControl(this.filters)
		);

		filters.valueChanges
			.pipe(
				debounceTime(200),
				distinctUntilChanged(),
				takeUntil(this.destroyed)
			)
			.subscribe((v) =>
				this.store.dispatch(filtersUpdated({ filters: v }))
			);

		// Initialize filters with URL value
		this.store
			.pipe(
				select(AdminUserSelectors.getListArgs),
				filter<UserListArgs>(Boolean),
				takeUntil(this.destroyed)
			)
			.subscribe((f) => filters.setValue(f));
	}

	applyFilter(filterValue: string) {
		this.dataSource.filter = filterValue.trim().toLowerCase();
	}
}
